import { isEmpty, toUpper } from 'lodash';

const makeVendorOption = (vendor) => {
  if (isEmpty(vendor)) return null;

  const {
    email,
    company_name,
    first_name,
    last_name,
    id,
    internal_id,
    contacts,
  } = vendor;

  return {
    label: toUpper(
      `${company_name || `${first_name} ${last_name}`} (${email}${
        internal_id ? ` - ${internal_id}` : ''
      })`,
    ),
    value: id,
    contacts,
  };
};

export default makeVendorOption;
